import React, { useEffect, useRef, useState } from 'react';
import { images } from '../data/mock';

const ConceptSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section
      id="concept"
      ref={sectionRef}
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image Full Screen */}
      <div className="absolute inset-0 z-0">
        <img
          src={images.hero[1]}
          alt="La Grande Brune Ambiance"
          className="w-full h-full object-cover"
          style={{ objectPosition: '50% 35%' }}
        />
        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      {/* Content Overlay */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div
            className={`transform transition-all duration-1000 ${
              isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
            }`}
          >
            <div className="inline-block bg-white text-black px-4 py-2 rounded-md text-sm font-semibold mb-6">
              ✨ Notre Concept
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-8 leading-tight">
              L'art de recevoir, réinventé
            </h2>
            <div className="space-y-6 text-lg text-white leading-relaxed max-w-3xl mx-auto">
              <p>
                Dans un cadre d'exception, chaque détail est pensé pour éveiller vos sens.
              </p>
              <p>
                De la cuisine aux lumières, de la musique à l'énergie du lieu, tout s'unit
                pour créer une expérience unique, élégante et inoubliable.
              </p>
            </div>
            <div className="mt-10 grid grid-cols-3 gap-6 max-w-2xl mx-auto">
              <div className="text-center bg-white/10 backdrop-blur-sm rounded-lg py-6 px-1">
                <div className="text-base md:text-2xl font-bold text-white mb-2 whitespace-nowrap">10:00 - 00:30</div>
                <div className="text-xs md:text-sm text-gray-200">Horaires</div>
              </div>
              <div className="text-center bg-white/10 backdrop-blur-sm rounded-lg py-6">
                <div className="text-3xl md:text-4xl font-bold text-white mb-2">7j/7</div>
                <div className="text-xs md:text-sm text-gray-200">Ouvert</div>
              </div>
              <div className="text-center bg-white/10 backdrop-blur-sm rounded-lg py-6">
                <div className="text-3xl md:text-4xl font-bold text-white mb-2">★★★★★</div>
                <div className="text-xs md:text-sm text-gray-200">Excellence</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConceptSection;
